import { text } from './text';
import type { ReportFieldType } from './types';

export const textarea: ReportFieldType = text;
